var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "Polaris-Tag"
  }, [_c('span', [_vm._t("default")], 2), _vm._v(" "), _c('button', {
    staticClass: "Polaris-Tag__Button",
    attrs: {
      "aria-label": "Remove"
    },
    on: {
      "click": _vm.onRemove,
      "mouseUp": _vm.handleMouseUp
    }
  }, [_c('polaris-icon', {
    attrs: {
      "source": _vm.cancelSmall
    }
  })], 1)])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-726f478b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-726f478b","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisTag.vue
// module id = 296
// module chunks = 0